let computed = require('../computed/account/users-list');

module.exports = {
    setComputedFields (args, state) {
        computed.formatUsersList(state);
        computed.filterUsersList(state);
    },

    isUserSelected ({ userId }, state, output) {
        if (userId) {
            output.yes({ userId });
            return;
        }

        output.no();
    }
};



// WEBPACK FOOTER //
// ./actions/account/users-list.js